
(() => {
  const ready = () => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const revealItems = document.querySelectorAll('[data-gt-reveal]');
    if (reduced || !('IntersectionObserver' in window)) {
      revealItems.forEach((el) => el.classList.add('is-visible'));
    } else {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });
      revealItems.forEach((el) => observer.observe(el));
    }

    document.querySelectorAll('[data-gt-before-after]').forEach((wrap) => {
      const input = wrap.querySelector('input[type="range"]');
      if (!input) return;
      const update = () => wrap.style.setProperty('--position', `${input.value}%`);
      input.addEventListener('input', update);
      update();
    });

    document.querySelectorAll('[data-gt-faq]').forEach((group) => {
      group.querySelectorAll('details').forEach((detail) => {
        detail.addEventListener('toggle', () => {
          if (!detail.open) return;
          group.querySelectorAll('details[open]').forEach((other) => {
            if (other !== detail) other.removeAttribute('open');
          });
        });
      });
    });

    document.querySelectorAll('[data-gt-gallery]').forEach((gallery) => {
      const main = gallery.querySelector('[data-gt-gallery-main]');
      const buttons = gallery.querySelectorAll('[data-src]');
      if (!main || !buttons.length) return;
      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          main.src = button.dataset.src;
          main.alt = button.dataset.alt || main.alt;
          buttons.forEach((item) => item.classList.toggle('is-active', item === button));
        });
      });
    });

    const mobileBar = document.querySelector('[data-gt-mobile-buy]');
    if (mobileBar) {
      const toggle = () => mobileBar.classList.toggle('is-visible', window.scrollY > 520);
      toggle();
      window.addEventListener('scroll', toggle, { passive: true });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
